import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { CommonService } from "../common.service";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";
import {
  SignalRConnection,
  BroadcastEventListener,
  ConnectionStatus,
  ConnectionStatuses
} from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { WidgethelperService } from "../widgethelper.service";

@Injectable()
export class PulltimemonitorService {
  private hub: SignalRConnection;

  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { }

  chartOptions() {
    return {
      legend: {
        data: ["orders", "units"],
        textStyle: {
          color: "#e6e6e6"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: this._widgetHelper.PulltimemonitorTooltip
      },
      xAxis: {
        boundaryGap: true,
        axisTick: {
          show: true,
          alignWithLabel: true
        },
        data: [], // category,
        offset: 18,
        axisLine: {
          lineStyle: {
            color: "#ccc"
          }
        }
      },
      grid: {
        bottom: 80,
        left: 0,
        right: 0,
        width: "100%"
      },
      yAxis: {
        splitLine: { show: false },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#575757"
          }
        },
        axisLabel: {
          show: false,
          formatter: this._widgetHelper.PulltimemonitorAxisLabel
        }
      },
      series: [
        {
          name: "Trend",
          type: "line",
          smooth: true,
          showAllSymbol: true,
          symbol: "circle",
          itemStyle: {
            normal: {
              color: "#77007E"
            }
          },
          symbolSize: 40,
          symbolPosition: "start",
          lineStyle: {
            normal: {
              opacity: 1
            }
          },
          label: {
            normal: {
              formatter: this._commonService.getTimeDiffFormatter,
              position: "inside",
              show: true,
              textStyle: {
                color: "#fff",
                decoration: "none",
                fontWeight: "200",
                fontFamily: "Verdana, sans-serif",
                fontSize: 9
              }
            }
          },
          data: [] // lineData
        },
        {
          name: "Shipped Orders",
          type: "bar",
          barWidth: 10,
          itemStyle: {},
          data: [] //barData
        },
        {
          name: "Pending Orders",
          type: "bar",
          barGap: "-100%",
          barWidth: 10,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "top",
                offset: [0, -25],
                formatter: "[ " + "{c}" + " ]",
                textStyle: {
                  color: "#ccc",
                  fontWeight: "normal"
                }
              }
            }
          },
          z: -12,
          data: [] // lineData
        },
        {
          name: "dotted",
          type: "pictorialBar",
          symbol: "rect",
          itemStyle: {
            normal: {
              color: "#000"
            }
          },
          symbolRepeat: true,
          symbolSize: [12, 4],
          symbolMargin: 1,
          z: -10,
          data: [] // lineData
        }
      ]
    };
  }

  init(widget: any) {
    console.log("Pull-Time Monitor");
    widget.dataLoaded = false;
    let currentDateTime = moment()
      .toDate()
      .getTime();
    widget.Title = "Pull-Time Monitor";
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor("broadcastPullTimesMonitor")
          .subscribe(
            (result: Array<any>) => {
              console.log("broadcastPullTimesMonitor", result);
              
              let resultwid;
              let resultcreationtime;
              let tmpMonitorType;
              let latestTime;
              if (result.length > 0) {
                widget.IfNoDataFound = result[0].IsNoDataFound;
                resultwid = result[0].widgetid;
                tmpMonitorType = result[0].MonitorType;
                resultcreationtime = result[0].widgetcreationtime;
                latestTime = result[0].LastUpdateTime;
              }
              if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
                widget.dataLoaded = false;
                widget.chartOptions = this.chartOptions();
                widget.errorMessage = null;
                let tmpline = 0;
                let category_tmp = [];
                let lineData_tmp = [];
                let lineData_tmp2 = [];
                let barData_tmp = [];
                let lineData_tmp3 = [];
                if (tmpMonitorType == null) {
                  tmpMonitorType = "ORDERS";
                }
                let hasData: boolean = false;
                result.sort(function (a, b) { return a.PullTime.toLowerCase() < b.PullTime.toLowerCase() ? -1 : 1; });
                for (let i = 0; i < result.length; i++) {
                  if (!widget.IfNoDataFound) {
                    hasData = true;
                    tmpline = 0;
                    let objitemStyleRed =
                      "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(255,0,0,0.2)'}, {offset: 0.2, color: 'rgba(255,0,0,0.4)'}, {offset: 1, color: 'rgba(255,0,0,0.8)'} ] } } ";
                    let objitemStyleGreen =
                      "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(0,255,0,0.2)'}, {offset: 0.2, color: 'rgba(0,255,0,0.4)'}, {offset: 1, color: 'rgba(0,255,0,0.8)'} ] } } ";
                    let objitemStyleYellow =
                      "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(255,255,0,0.2)'}, {offset: 0.2, color: 'rgba(255,255,0,0.4)'}, {offset: 1, color: 'rgba(255,255,0,0.8)'} ] } } ";

                    let objShippedStyleRed =
                      " normal: { barBorderRadius: 5,color: {type: 'linear',x:0,y:0,x2:0,y2:1,colorStops:[{offset: 0, color: '#8cc63f'},{offset: 1, color: '#22b573'}]},label:{show: true,position: 'left',textStyle:{color:'#8cc63f'}}}";
                    let objShippedStyleGreen =
                      " normal: { barBorderRadius: 5,color: {type: 'linear',x:0,y:0,x2:0,y2:1,colorStops:[{offset: 0, color: '#008000'},{offset: 1, color: '#7fbf7f'}]},label:{show: true,position: 'left',textStyle:{color:'#008000'}}}";
                    let objShippedStyleYellow =
                      " normal: { barBorderRadius: 5,color: {type: 'linear',x:0,y:0,x2:0,y2:1,colorStops:[{offset: 0, color: '#ffff00'},{offset: 1, color: '#ffff99'}]},label:{show: true,position: 'left',textStyle:{color:'#ffff00'}}}";

                    let xaxisvalue = result[i].PullTime; // + '\n' + result[i].Carrier;
                    if (result[i].Carrier != null) {
                      xaxisvalue =
                        result[i].PullTime +
                        "\n\n" +
                        result[i].Carrier.split("-")[0] +
                        "\n" +
                        result[i].Carrier.split("-")[1];
                    }
                    //console.log('xaxisvalue',xaxisvalue);
                    if (tmpMonitorType == "ORDERS") {
                      tmpline = result[i].PendingOrders + result[i].ShippedOrders;
                      category_tmp.push(xaxisvalue);
                      if (result[i].PullTimePerformaceRate < 90) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(255,0,0,0.2)" },
                                  { offset: 0.2, color: "rgba(255,0,0,0.4)" },
                                  { offset: 1, color: "rgba(255,0,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedOrders,
                          name: result[i].ShippedOrders,
                          itemStyle: { normal: { color: "red" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleRed }
                        });
                      } else if (
                        result[i].PullTimePerformaceRate >= 90 &&
                        result[i].PullTimePerformaceRate < 100
                      ) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(255,255,0,0.2)" },
                                  { offset: 0.2, color: "rgba(255,255,0,0.4)" },
                                  { offset: 1, color: "rgba(255,255,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedOrders,
                          name: result[i].ShippedOrders,
                          itemStyle: { normal: { color: "yellow" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleYellow }
                        });
                      } else if (result[i].PullTimePerformaceRate >= 100) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(0,255,0,0.2)" },
                                  { offset: 0.2, color: "rgba(0,255,0,0.4)" },
                                  { offset: 1, color: "rgba(0,255,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedOrders,
                          name: result[i].ShippedOrders,
                          itemStyle: { normal: { color: "green" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleGreen }
                        });
                      }

                      lineData_tmp.push({
                        value: tmpline,
                        name: tmpline,
                        pulltime: xaxisvalue,
                        Pending: result[i].PendingOrders
                      });
                    }
                    else {
                      tmpline =
                        result[i].PendingQuantity + result[i].ShippedQuantity;
                      //category_tmp.push(result[i].PullTime);
                      category_tmp.push(xaxisvalue);
                      //console.log(result[i].PullTimePerformaceRate);
                      if (result[i].PullTimePerformaceRate < 90) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(255,0,0,0.2)" },
                                  { offset: 0.2, color: "rgba(255,0,0,0.4)" },
                                  { offset: 1, color: "rgba(255,0,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedQuantity,
                          name: result[i].ShippedQuantity,
                          itemStyle: { normal: { color: "red" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleRed }
                        });
                      } else if (
                        result[i].PullTimePerformaceRate >= 90 &&
                        result[i].PullTimePerformaceRate < 100
                      ) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(255,255,0,0.2)" },
                                  { offset: 0.2, color: "rgba(255,255,0,0.4)" },
                                  { offset: 1, color: "rgba(255,255,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedQuantity,
                          name: result[i].ShippedQuantity,
                          itemStyle: { normal: { color: "yellow" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleYellow }
                        });
                      } else if (result[i].PullTimePerformaceRate >= 100) {
                        lineData_tmp2.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: {
                            normal: {
                              color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                  { offset: 0, color: "rgba(0,255,0,0.2)" },
                                  { offset: 0.2, color: "rgba(0,255,0,0.4)" },
                                  { offset: 1, color: "rgba(0,255,0,0.8)" }
                                ]
                              }
                            }
                          }
                        });

                        barData_tmp.push({
                          value: result[i].ShippedQuantity,
                          name: result[i].ShippedQuantity,
                          itemStyle: { normal: { color: "green" } }
                        });

                        lineData_tmp3.push({
                          value: tmpline,
                          name: tmpline,
                          itemStyle: { objitemStyleGreen }
                        });
                      }
                      lineData_tmp.push({
                        value: tmpline,
                        name: tmpline,
                        pulltime: xaxisvalue,
                        Pending: result[i].PendingQuantity
                      });
                    }
                  }
                }

                if (!hasData) {
                  widget.errorMessage = errorMessages.noWidgetData;
                }
                else {
                  widget.errorMessage = null;
                }
                widget.chartOptions.xAxis.data = category_tmp;
                widget.chartOptions.series[0].data = lineData_tmp; //lineData;
                widget.chartOptions.series[1].data = barData_tmp;
                widget.chartOptions.series[2].data = lineData_tmp2; //barData;
                widget.chartOptions.series[3].data = lineData_tmp3;
                this._commonService.lastUpdatedTime = latestTime;
              }
              //console.log(result)  ;
              widget.dataLoaded = true;
            },
            err => {
              console.log("listenFor broadcastPullTimesMonitor error", err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PULLTIMESMONITOR";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            //console.log("GetWidgetData", data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "PullTimesMonitor",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
            //do nothing
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "PULLTIMESMONITOR";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: 'PullTimesMonitor',
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment()
          .toDate()
          .getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam)
          .then((isWidgetConnected: any) => {
            if (isWidgetConnected) {
              //do nothing
            }
            console.log("deleteWidget PullTimesMonitor RemoveWidget");
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/pulltimemonitor.service.ts